<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              {{ header }}
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <p class="left">{{ body }}</p>
            </slot>
          </div>

          <div class="form-group">
            <label for="parentGroup">Parent group</label>
            <select
              v-model="layer.id_sup"
              class="form-control"
              id="parentGroup"
            >
              <option value="2">Gurs prostorski podatki</option>
              <option value="3">> Kataster</option>
              <option value="5">Občinski prostorski podatki</option>
            </select>
          </div>
          <div class="form-group">
            <label for="layerType">Layer type</label>
            <select v-model="layer.type" class="form-control" id="layerType">
              <option value="1">Header</option>
              <option value="2">Group</option>
              <option value="3">Shared layer</option>
              <option value="4">Layer</option>
              <option value="5">DWG</option>
            </select>
          </div>
          <div class="form-group">
            <label for="order">Menu order</label>
            <input
              type="number"
              v-model="layer.order"
              class="form-control"
              id="order"
              placeholder="Enter order in menu"
            />
          </div>
          <div class="form-group" v-show="isLayer">
            <label for="mapOrder">Map order</label>
            <input
              type="number"
              v-model="layer.map_order"
              class="form-control"
              id="mapOrder"
              placeholder="Enter order in map"
            />
          </div>
          <div class="form-group" v-show="isLayer">
            <label for="name">Name</label>
            <input
              type="text"
              v-model="layer.name"
              class="form-control"
              id="name"
              placeholder="Enter layer name"
            />
          </div>
          <div class="form-group" v-show="!isLayer">
            <label for="name">Label</label>
            <input
              type="text"
              v-model="layer.label"
              class="form-control"
              id="name"
              placeholder="Enter layer name"
            />
          </div>
          <div class="form-group" v-show="isLayer">
            <label for="mapfile">The mapfile content</label>
            <textarea
              v-model="layer.mapfile"
              class="form-control"
              id="mapfile"
              rows="8"
            ></textarea>
          </div>
          <div class="form-check">
            <input
              v-model="layer.checked"
              class="form-check-input"
              type="checkbox"
              value=""
              id="checked"
            />
            <label class="form-check-label" for="checked">
              Checked
            </label>
          </div>
          <div class="form-check" v-show="isLayer">
            <input
              v-model="layer.info.enabled"
              class="form-check-input"
              type="checkbox"
              value=""
              id="checked"
            />
            <label class="form-check-label" for="checked">
              Info field
            </label>
          </div>
          <div class="form-group" v-show="layer.info.enabled && isLayer">
            <label for="infoFields">Info fields</label>
            <input
              type="text"
              v-model="layer.info.fields"
              class="form-control"
              id="infoFields"
              placeholder="Enter info fields"
            />
          </div>
          <div class="form-group" v-show="layer.info.enabled && isLayer">
            <label for="infoLabels">Info labels</label>
            <input
              type="text"
              v-model="layer.info.labels"
              class="form-control"
              id="infoLabels"
              placeholder="Enter info labels"
            />
          </div>
          <div class="form-group" v-show="isLayer">
            <label for="minScale">Min. scale</label>
            <input
              type="number"
              v-model="layer.min_scale"
              class="form-control"
              id="minScale"
              placeholder="Enter minimal scale"
            />
          </div>
          <div class="form-group" v-show="isLayer">
            <label for="maxScale">Max. scale</label>
            <input
              type="number"
              v-model="layer.max_scale"
              class="form-control"
              id="maxScale"
              placeholder="Enter maximal scale"
            />
          </div>
          <div class="form-group" v-show="isLayer">
            <label for="position">Position</label>
            <input
              type="text"
              v-model="layer.position"
              class="form-control"
              id="position"
              placeholder="Enter position on layer enable"
            />
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-danger" @click="$emit('close', true)">
                {{ $t("confirm") }}
              </button>
              <button class="btn btn-secondary" @click="$emit('close', false)">
                {{ $t("cancel") }}
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { layers as layersService } from "../../services";
export default {
  data: function() {
    return {
      definitionType: "layer",
      layer: {
        id_sup: null,
        type: 4,
        order: 0,
        map_order: null,
        name: "",
        label: "",
        mapfile: "",
        checked: true,
        info: {
          enabled: true,
          fields: [],
          labels: []
        },
        min_scale: 10,
        max_scale: 50000,
        position: []
      }
    };
  },
  computed: {
    isLayer: function() {
      return this.definitionType === "layer";
    }
  },
  watch: {
    "layer.type": function(val) {
      if (val < 3) {
        this.definitionType = "base";
      } else {
        this.definitionType = "layer";
      }
    }
  },
  props: {
    header: {
      type: String,
      default: "Item removal"
    },
    body: {
      type: String,
      default: "Are you sure you wnat to remove item"
    },
    id: {
      type: Number,
      default: 0
    }
  },
  methods: {
    loadLayerDetails() {
      if (!this.id) {
        return;
      }

      layersService
        .getLayer(this.id)
        .then(data => {
          this.layer = data;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    console.log("layer dialog mounted");
    this.loadLayerDetails();
  }
};
</script>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 650px;
  margin: 0px auto;
  padding: 20px 30px;
  text-align: left;
  max-height: 80%;
  overflow-y: scroll;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.left {
  text-align: left;
}

label {
  text-align: right;
}
</style>
